import KebabMenu from "../../../components/kebabMenu/KebabMenu";
import type { Line } from "../../../components/kebabMenu/KebabMenu";

export const WrappedKebabMenu = ({ lines }: { lines: Line[] }) => {
    return (
        <div className="w-100 h-100 d-flex align-items-center justify-content-center">
            <KebabMenu lines={lines} activeColor="var(--primary-bright)" />
        </div>
    );
}; 